import { fork, all } from 'redux-saga/effects'
import userSaga from 'store/user/userSaga'
import asyncErrorSaga from 'store/asyncError/asyncErrorSaga'
import loginSaga from 'store/login/loginSaga'
import editSessionSaga from 'store/editSession/editSessionSaga'
import modalSaga from 'store/modal/modalSaga'
import projectListSaga from 'store/projectList/projectListSaga'
import moderatorListSaga from 'store/moderatorList/moderatorListSaga'
import projectSaga from 'store/project/projectSaga'
import projectCreationSaga from 'store/projectCreation/projectCreationSaga'
import sidebarSaga from 'store/sidebar/sidebarSaga'
import schedulerSaga from 'store/scheduler/schedulerSaga'
import projectManagerListSaga from 'store/projectManagerList/projectManagerListSaga'
import interviewsListSaga from 'store/interviewsList/interviewsListSaga'
import moderatorSaga from 'store/moderator/moderatorSaga'
import interviewPaymentStatusSaga from 'store/interviewPaymentStatuses/InterviewPaymentStatusSaga'
import incentiveUpdateSaga from 'store/incentiveUpdate/incentiveUpdateSaga'
import creditIncentiveSaga from 'store/creditIncentive/creditIncentiveSaga'

export default function* watchSagas () {
  yield all([
    asyncErrorSaga,
    loginSaga,
    userSaga,
    editSessionSaga,
    modalSaga,
    projectListSaga,
    moderatorListSaga,
    projectSaga,
    sidebarSaga,
    schedulerSaga,
    moderatorSaga,
    projectCreationSaga,
    projectManagerListSaga,
    interviewsListSaga,
    interviewPaymentStatusSaga,
    incentiveUpdateSaga,
    creditIncentiveSaga
  ].map(fork))
}
